import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const LaptopIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Laptop</title>
    <path d="M 38 10 H 10 C 7.79086 10 6 11.7909 6 14 V 32 H 42 V 14 C 42 11.7909 40.2091 10 38 10 Z M 38 28 H 10 V 14 H 38 V 28 Z M 44 34 H 4 C 4 36.2091 5.79086 38 8 38 H 40 C 42.2091 38 44 36.2091 44 34 Z" />
  </IconBase>
);
